import { createPromiseAction } from 'redux-saga-promise-actions';

import { Installments, GetInstallmentsPayload } from 'store/types/installments';

export const getInstallments = createPromiseAction(
  'GET_INSTALLMENTS',
  'GET_INSTALLMENTS_SUCCEEDED',
  'GET_INSTALLMENTS_FAILURE',
)<{ price: string }, { installments: Installments[] }, undefined>();
